import React from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../shared/constants/routes';
import { bandTextColor, bandRingColor } from './ReadinessRing';
import TrendArrow from './TrendArrow';

function topicName(topic) {
  return topic.display_name || topic.subtopic || topic.topic || 'Untitled';
}

function hasPracticed(topic) {
  return topic.raw_confidence != null && !topic.is_estimated;
}

export default function SubtopicRow({
  topic,
  variant = 'l3',   // 'l3' (inside expanded SU) or 'ds' (detailed subtopics view)
  selected = false,
  trend = null,
  onClick,
}) {
  const navigate = useNavigate();
  const readiness = topic.raw_confidence ?? topic.confidence ?? null;
  const notStarted = readiness == null;
  const pct = readiness != null ? Math.round(readiness * 100) : null;
  const color = bandTextColor(readiness);
  const name = topicName(topic);

  const selfRated = topic.confidence != null && topic.is_estimated !== false && !hasPracticed(topic);
  const practised = hasPracticed(topic);
  const confidencePct = topic.confidence != null ? topic.confidence * 100 : null;
  const readinessPct = readiness != null ? readiness * 100 : null;
  const showGapAlert = confidencePct != null && readinessPct != null
    && confidencePct - readinessPct >= 15;

  const handlePractice = (e) => {
    e.stopPropagation();
    navigate(`${ROUTES.QUESTIONS}?mode=topic&topic_id=${topic.id}`);
  };

  if (variant === 'ds') {
    const rowClass = `tv3-ds-card${notStarted ? ' tv3-not-started' : ''}${selected ? ' tv3-open' : ''}`;
    return (
      <div className={rowClass} onClick={onClick}>
        <span className="tv3-l3-readiness" style={{ color }}>
          {pct != null ? `${pct}%` : '—'}
        </span>
        <span className="tv3-l3-name">{name}</span>
        <div className="tv3-l3-right">
          {trend && <TrendArrow direction={trend} />}
          <div className="tv3-mini-bar">
            {readinessPct != null && (
              <div
                className="tv3-mini-bar-fill"
                style={{ width: `${readinessPct}%`, background: bandRingColor(readiness) }}
              />
            )}
          </div>
          {showGapAlert && (
            <span className="tv3-gap-alert">
              Confidence {Math.round(confidencePct)}% · Readiness {Math.round(readinessPct)}%
            </span>
          )}
          {practised && <span className="tv3-l3-status tv3-practised">Practised</span>}
          {selfRated && !practised && <span className="tv3-l3-status tv3-self-rated">Self-rated</span>}
          <span className={`tv3-chevron${selected ? ' tv3-open' : ''}`}>›</span>
        </div>
      </div>
    );
  }

  // L3 variant (inside expanded SU)
  return (
    <div className="tv3-l3-row" onClick={onClick}>
      <span className="tv3-l3-readiness" style={{ color }}>
        {pct != null ? `${pct}%` : '—'}
      </span>
      <span className="tv3-l3-name">{name}</span>
      <div className="tv3-l3-right">
        {trend && <TrendArrow direction={trend} />}
        {showGapAlert && (
          <span className="tv3-gap-alert">
            Confidence {Math.round(confidencePct)}% · Readiness {Math.round(readinessPct)}%
          </span>
        )}
        {practised && <span className="tv3-l3-status tv3-practised">Practised</span>}
        {selfRated && !practised && <span className="tv3-l3-status tv3-self-rated">Self-rated</span>}
        {!notStarted && (
          <button className="tv3-btn-practice" onClick={handlePractice}>Practice</button>
        )}
        <span className={`tv3-chevron${selected ? ' tv3-open' : ''}`}>›</span>
      </div>
    </div>
  );
}
